<template>
	<div class="flex flex-col gap-3">
		<SearchModel v-if="colleges.length < 3" attribute="name" :label="trans('events.requests.colleges')" search-type="colleges" required @selected="add"/>
		<div v-for="college in colleges" :key="`college-${college.id}`" class="input-like flex items-center gap-2">
			<p class="grow">{{ college.name }}</p>
			<CloseSelected @click.stop="remove(college)"/>
		</div>
	</div>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {defineProps, ref, type Ref} from 'vue'
import {type College} from '@/Types/Settings/College'
import SearchModel from '@/Components/Search/SearchModel.vue'
import CloseSelected from '@/Components/Search/CloseSelected.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/helpers'

const props = defineProps<{
	colleges:Array<College>,
	eventId?:number,
	manage?:boolean,
}>()

const manage:Ref<boolean> = ref(props.manage)
const working:Ref<boolean> = ref(false)
const colleges:Ref<Array<College>> = ref(props.colleges)

function add(college:College):void{
	if(manage.value){
		if(!working.value){
			working.value = true
			showInfo(trans('general.updating'))
			axios.post(route('events.colleges.attach', {
				event: props.eventId,
				college: college.id,
			})).then(() => {
				showSuccess(trans('general.updated'))
				push(college)
			}).catch(showValidationErrors).finally(() => {
				working.value = false
			})
		}
	} else {
		push(college)
	}
}

function push(college:College):void{
	colleges.value.push(college)
}

function remove(college:College):void{
	if(manage.value){
		if(!working.value){
			working.value = true
			showInfo(trans('general.deleting'))
			axios.delete(route('events.colleges.detach', {
				event: props.eventId,
				college: college.id,
			})).then(() => {
				showSuccess(trans('general.deleted'))
				splice(college)
			}).catch(showValidationErrors).finally(() => {
				working.value = false
			})
		}
	} else {
		splice(college)
	}
}

function splice(college:College):void{
	const index = colleges.value.findIndex((c:College) => c.id === college.id)
	if(index > -1){
		colleges.value.splice(index, 1)
	}
}
</script>